import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Welcome from "./components/Welcome";
import Dashboard from "./Dashboard/Main/Dashboard";
import { useAppSelector } from "./store/hooks";
import "./App.css";

const App = () => {
  const showWelcome = useAppSelector((state) => state.chat.showWelcome);

  return (
    <Routes>
      <Route path="/analytics" element={<Dashboard />} />
      <Route
        path="*"
        element={<div className="chatbox">{showWelcome ? <Welcome /> : <Home />}</div>}
      />
    </Routes>
  );
};

export default App;

